import React from 'react'
import Roadmap_Component from './Roadmap_Component'

function Third_Component() {
  return (
    <div>
      <div className='container-fluid d-none d-xl-block Roadmap_background pb-5'>
        <div className='row'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
            <Roadmap_Component/>
          </div>
          <div className='col-md-1'></div>
        </div>
      </div>
    </div>
  )
}

export default Third_Component
